import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "ids"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { NullContainer } from '@beef/utils';
import * as RC from '@beef/redux-current';
import { createInjectableSelector } from "./legacy";
export var mergeIds = function mergeIds(selectedIds, ownIds) {
  if (typeof ownIds === 'function') return ownIds(selectedIds);
  return ownIds || selectedIds;
};
export var createMapperHOC = function createMapperHOC(CurrentProvider, selectIds) {
  return function (WrappedComponent) {
    var _CurrentMapper = function _CurrentMapper(_ref) {
      var children = _ref.children,
        ids = _ref.ids,
        props = _objectWithoutProperties(_ref, _excluded);
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
        "data-t-id": "src-redux-current"
      }), ids.map(function (id) {
        return /*#__PURE__*/React.createElement(CurrentProvider, {
          key: id,
          value: id
        }, children);
      }));
    };
    return connect(function (state, ownProps) {
      return {
        // allow modifying ids by passing ownProps.ids {func|array}
        ids: mergeIds(selectIds(state), ownProps.ids)
      };
    }, {})(_CurrentMapper);
  };
};

/**
 * @template L
 * @param {L | undefined} selectDataList
 * @param selectId?
 * @param KEY?: string | symbol
 * @deprecated use combination of CurrentProvider, CurrentProvider.Mapper
 *   and createInjectableSelector from '@beef/redux-current'
 * @returns {((state: any) => any) & L extends undefined ? unknown : {
      withCurrentProviderMapper: any,
 *    CurrentProvider: any,
 *    CurrentProviderMapper: any,
 *    selectCurrent: any,
 *    selectIds: any,
 *  }}
 */
export var createCurrentSelector = function createCurrentSelector(selectDataList) {
  var selectId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (item) {
    return item.id;
  };
  var KEY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : RC.generateCurrentKey();
  var selectCurrent = createInjectableSelector(KEY);
  /**
   * @returns any
   */
  if (!selectDataList) return selectCurrent;
  var selectIds = createSelector(selectDataList, function (list) {
    return list.map(selectId);
  });
  var selectDict = createSelector(selectDataList, function (list) {
    return list.reduce(function (accum, item) {
      return _objectSpread(_objectSpread({}, accum), {}, _defineProperty({}, selectId(item), item));
    }, []);
  });
  var CurrentProvider = function CurrentProvider(_ref2) {
    var value = _ref2.value,
      children = _ref2.children;
    return /*#__PURE__*/React.createElement(RC.CurrentProvider, {
      name: KEY,
      value: useSelector(selectDict)[value]
    }, children);
  };
  var withCurrentProviderMapper = createMapperHOC(CurrentProvider, selectIds);
  var CurrentProviderMapper = withCurrentProviderMapper(NullContainer);

  /** Let all these props be available as properties of the main function */
  return Object.assign(selectCurrent, {
    withCurrentProviderMapper: withCurrentProviderMapper,
    CurrentProvider: CurrentProvider,
    CurrentProviderMapper: CurrentProviderMapper,
    selectCurrent: selectCurrent,
    selectIds: selectIds
  });
};

/**
 * @deprecated use combination of CurrentProvider, CurrentProvider.Mapper
 *   and createInjectableSelector from '@beef/redux-current'
 */
export var createCurrentHOC = function createCurrentHOC(selectDataList, selectId, KEY) {
  var _createCurrentSelecto = createCurrentSelector(selectDataList, selectId, KEY),
    selectCurrent = _createCurrentSelecto.selectCurrent,
    withCurrentProviderMapper = _createCurrentSelecto.withCurrentProviderMapper;
  return [selectCurrent, withCurrentProviderMapper];
};

/**
 * @deprecated use combination of CurrentProvider, CurrentProvider.Mapper
 *   and createInjectableSelector from '@beef/redux-current'
 */
export var createCurrentAdapter = createCurrentSelector;